import * as checkoutService from '/source/js/services/checkoutService';
import { loadSpinner, stopSpinner } from '/source/_patterns/01-components/spinner/spinner';

async function ValidateGenericAdvancedModal() {
    let isValid = true;
    const $parent = $(this).closest('.advanced-modal');
    if($parent.length > 0) {
        const hasDualContent = $($parent).find('.consents.custom-tabs').length > 0;
        const $child = $parent.find('.advanced-modal_checkbox_content');
        if($child.length > 0 || hasDualContent) {
            let $checkboxes = $($child).find('.advance-checkbox');
            if(hasDualContent) {
                $checkboxes = $($parent).find('.consents.custom-tabs .tab-pane.active .advance-checkbox');
            }
            $checkboxes.each(function (index) {
                // Get the current checkbox element
                const $checkbox = $(this);
                if($checkbox.data('rule-required')) {
                    let checked = $checkbox.is(':checked');
                    if(!checked) {
                        $('#terms-required-message-' + $checkbox.attr('id')).removeClass('d-none');
                        isValid = false;
                    }
                }
            });
        }
    }
    if(isValid) {
        $('.generic-advanced-primary-btn').prop('disabled', true);
        loadSpinner();
        if($(this).data('submit-url') != null) {
            stopSpinner();
            window.location.href = $(this).data('submit-url');
        } else {
            let result = await checkoutService.convertMembertoBP();
            if(result.isSuccess) {
                stopSpinner();
                window.location = result.redirectUrl;
            } else {
                stopSpinner();
                $('#bp-conversion-failed-msg').removeClass('d-none');
            }
        }
    }
}

function RefreshModal() {
    $('.generic-advanced-primary-btn').prop('disabled', false);
    const $parent = $(this).closest('.advanced-modal');
    if($parent.length > 0) {
        const hasDualContent = $($parent).find('.consents.custom-tabs').length > 0;
        const $child = $parent.find('.advanced-modal_checkbox_content');
        if($child.length > 0 || hasDualContent) {
            let $checkboxes = $($child).find('.advance-checkbox');
            if(hasDualContent) {
                $checkboxes = $($parent).find('.consents.custom-tabs .tab-pane.active .advance-checkbox');
            }
            $checkboxes.each(function () {
                const $checkbox = $(this);
                $checkbox.prop('checked', false);
                $('#terms-required-message-' + $checkbox.attr('id')).addClass('d-none');
            });
        }
    }
}

$(function () {
    $('.generic-advanced-primary-btn').on('click', ValidateGenericAdvancedModal);
    $('.generic-advanced-secondary-btn').on('click', RefreshModal);
    $('.generic-advanced-close-btn').on('click', RefreshModal);
    $('[id^="tab-group-"]').each(function () {
        const tabGroupId = $(this).attr('id');
        $(`#${tabGroupId} a[data-toggle="tab"]`).on('shown.bs.tab', function (e) {
            const $tabGroup = $(`#${tabGroupId}`);
            const checkboxes = $tabGroup.find('.tab-pane input[type="checkbox"]');
            checkboxes.prop('checked', false);
            $(checkboxes).each(function () {
                const id = $(this).attr('id');
                if(id) {
                    const targetSpan = $('#terms-required-message-' + id);
                    if(!targetSpan.hasClass('d-none')) {
                        targetSpan.addClass('d-none');
                    }
                }
            });
        });
    });
    $('.isa-generic-modal input[type="checkbox"]').on('change', function () {
        if($(this).is(':checked')) {
            const id = $(this).attr('id');
            if(id) {
                const targetSpan = $('#terms-required-message-' + id);
                if(!targetSpan.hasClass('d-none')) {
                    targetSpan.addClass('d-none');
                }
            }
        }
    });
});
